import React from 'react';
import { Link } from 'react-router-dom';
import { Activity, ArrowRight, ShieldCheck, Stethoscope, Workflow } from 'lucide-react';
import SEO from '../components/SEO';
import { Section } from '../components/Section';

export default function CRMLandingPage() {
  return (
    <>
      <SEO
        title="CRM clínico con IA | Neuralia369"
        description="CRM clínico con IA para captación, seguimiento, priorización y operación de clínicas, consultas y equipos sanitarios."
        path="/crm-clinico-ia"
        keywords="CRM clínico IA, software clínica con IA, seguimiento pacientes IA, leads clínica, automatización clínica"
      />
      <div className="min-h-screen bg-background pt-24 pb-20" data-testid="crm-landing-page">
        <Section>
          <div className="max-w-6xl mx-auto grid gap-10 xl:grid-cols-[1fr_1fr]">
            <div>
              <p className="editorial-kicker mb-4">Neuralia369 · CRM clínico</p>
              <h1>CRM clínico con IA para captar, priorizar y dar seguimiento con <span className="gradient-text">menos fricción</span></h1>
              <p className="mt-6 text-lg text-text-body">Pensado para clínicas y consultas que quieren ver mejor su operación comercial, clasificar oportunidades y actuar antes de perder pacientes potenciales.</p>
              <div className="mt-8 flex flex-wrap gap-4">
                <Link to="/contacto" className="btn-primary" data-testid="crm-contact-cta">Quiero un CRM clínico<ArrowRight className="w-5 h-5" /></Link>
                <Link to="/clinical-demo-form" className="btn-secondary" data-testid="crm-demo-cta">Ver demo</Link>
              </div>
            </div>
            <div className="grid gap-4 md:grid-cols-2">
              {[
                { icon: Stethoscope, title: 'Leads y citas', copy: 'Captación, clasificación y agenda con visión comercial.' },
                { icon: Activity, title: 'Semáforo de riesgo', copy: 'Prioriza contactos que requieren acción rápida.' },
                { icon: Workflow, title: 'Importación inteligente', copy: 'Sube Excel/CSV y organiza la base con criterio operativo.' },
                { icon: ShieldCheck, title: 'Trazabilidad', copy: 'Historial y control para seguimiento clínico y comercial.' },
              ].map(({ icon: Icon, title, copy }) => (
                <div key={title} className="glass-card tracing-panel p-6" data-testid={`crm-landing-card-${title}`}>
                  <Icon className="w-6 h-6 text-primary" />
                  <p className="mt-4 text-lg font-semibold text-text-heading">{title}</p>
                  <p className="mt-3 text-sm text-text-body">{copy}</p>
                </div>
              ))}
            </div>
          </div>
        </Section>
      </div>
    </>
  );
}